import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL, BRAND } from "@/data/site";

export const Seo = ({ title, description, path = "/", image = "/og-image.jpg", jsonLd = [], noindex = false }) => {
  const url = `${SITE_URL}${path === "/" ? "/" : path}`;
  const img = image.startsWith("http") ? image : `${SITE_URL}${image}`;
  useEffect(() => {
    document.querySelectorAll("[data-static-seo]").forEach((el) => el.remove());
  }, []);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {!noindex && <link rel="canonical" href={url} />}
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow, max-image-preview:large"} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd.map((d, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(d)}</script>
      ))}
    </Helmet>
  );
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${SITE_URL}${path}` })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })),
});

export const serviceSchema = (s, path) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name: s.title,
  description: s.metaDesc,
  url: `${SITE_URL}${path}`,
  serviceType: s.title,
  areaServed: "Worldwide",
  provider: { "@id": `${SITE_URL}/#organization` },
});
